import React from 'react';
import { motion } from 'framer-motion';

const Dashboard = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
      className="space-y-6"
    >
      {/* Page Header */}
      <div className="border-b border-white/6 pb-6">
        <h1 className="text-2xl font-heading font-semibold text-zinc-100">Dashboard</h1>
        <p className="text-sm text-zinc-400 mt-1">Welcome to your dashboard</p>
      </div>

      {/* Empty State */}
      <div className="flex items-center justify-center min-h-[400px] bg-[#0f1115] border border-white/10 rounded-lg">
        <div className="text-center">
          <div className="w-16 h-16 rounded-full bg-[#1a1d24] border border-white/10 flex items-center justify-center mx-auto mb-4">
            <svg
              className="w-8 h-8 text-zinc-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"
              />
            </svg>
          </div>
          <h3 className="text-lg font-heading font-semibold text-zinc-200 mb-2">Dashboard</h3>
          <p className="text-sm text-zinc-500 max-w-sm">
            Your dashboard content will appear here
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default Dashboard;
